<template>
    <div v-if="visible" class="card card-lv-warning text-center">
        <div class="card-body">
            <h5 class="fw-bold mt-1 mb-3">Need some help?</h5>
            <p class="mb-0">Call a retirement expert on <a class="fw-bold" href="tel:08000321925">0800 032 1925</a></p>
            <p class="mb-0">Mon-Fri 8:30am - 6:00pm. For text phone first dial 18001. Calls may be recorded and/or monitored for training and audit purposes.</p>
            <button
                class="btn btn-secondary mt-2 mb-2 w-auto border fw-bold callback-button no-hover"
                @click="onRequestCallback">
                Request a callback
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const visible = computed<boolean>(() => store.state.configuration.workflow?.showContactUsAd ?? false);

function onRequestCallback() {
    window.location.href = "https://www.lv.com/pensions-retirement/pension-drawdown-calculator/request-call-back";
}
</script>

<style scoped>

.card-lv-warning {
    background-color: #ecf5f8;
    border-radius: 16px;
}

.callback-button {
    border-color: #dee2e6 !important;
}

.callback-button:hover {
    color: #04589b !important;
    background-color: white !important;
    border-color: #dee2e6 !important;
}
</style>